export default "__VITE_ASSET__BjLC64wC__"